/**
 * Created by Christof Sander on 27.09.2016.
 */

module.exports = {
	extends: [
		'/',
		'templates',
		'atomTrees',
		'atomTrees'
	],

	config: {
		selectActualNodeAfterRefresh: false,
		selectNewNodeAfterRefresh: false
	},

	methods: {
		/**
		 * trigger onDecision if selection has been done.
		 *
		 * @param   data        {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;

			switch (data.onTreeActionOptions.eventType) {
				case 'select_node.jstree':
					if(!data.onTreeActionOptions.autoSelect || (this.config.decisionOptions && this.config.decisionOptions.decideOnAutoSelect)) {
						// show page actions if necessary
						this.triggerClosest('onDecision', {
							decisionComponent: self,
							decisionType: 'submit',
							decisionOptions: self.config.decisionOptions || {},
							data: data.onTreeActionOptions.nodeData
						});
					}
					break;
			}
		},

		/**
		 * this function will be called by the trees-component after the attach hook has been done.
		 * NOTE: this gives us the ability to react on the attach hook without overwriting it.
		 */
		onAttachDone: function(){}
	},

	// NOTE: prevent atomTrees handlers from being called for this selectAtomTrees-Component
	handlers: undefined
};
